import dynamic from 'next/dynamic';
import type { FC } from 'react';

import { Modal } from '~components/Modals/Base';

import type { TConfirmModalProps } from '../../model/types';
const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.Content),
	{
		ssr: false,
	}
);

export const ConfirmModal: FC<TConfirmModalProps> = ({
	open,
	locked,
	onClose,
	...props
}) => {
	return (
		<Modal open={open} locked={locked} onClose={onClose}>
			<Content open={open} locked={locked} onClose={onClose} {...props} />
		</Modal>
	);
};
